import React from "react";
import {
  Box,
  Button,
  ButtonGroup,
  Divider,
  Icon,
  Select,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import useProducts from "../store/hooks/useProducts";
import { Skeleton } from "@material-ui/lab";
import useFilters from "../store/hooks/useFilters";
import usePagination from "../store/hooks/usePagination";
import { useTranslation } from "react-i18next";
import { toNumber } from "lodash";
import EmployeeStoreClosedStoreBadge from "../layout/header/components/EmployeeStoreClosedStoreBadge";
import useLayout from "../store/hooks/useLayout";
import { MODE_GRID, MODE_LIST } from "../store/slices/createLayoutSlice";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "6px 12px",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      gap: "6px",
      alignItems: "flex-start",
      marginTop: "-6px",
    },
  },
  containerSelectBox: {
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },
  selectLabel: {
    fontWeight: 700,
  },
  select: {
    padding: 8,
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },
  selectRoot: {
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },
  endItems: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },
  buttonsChangeShowModeContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "1px solid gree",
  },
  counterPagination: {
    fontSize: "1rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.8rem",
    }
  }
}));

export default function TopBar() {
  const { t } = useTranslation();
  const classes = useStyles();
  const { loadingProducts } = useProducts();
  const { handleSorting, sortBy, sortDir, loadingFilters } = useFilters();
  const { totalItems, resultsCounter, page, totalPages } = usePagination();
  const theme = useTheme();
  const isXsDown = useMediaQuery(theme.breakpoints.down("xs"));
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));
  const { showHomeProductsMode, showHomeAsGrid, showHomeAsList } = useLayout();

  const handleSortChange = (event) => {
    const [sortBy, sortDir] = event.target.value.split("_");
    handleSorting(sortBy, sortDir);
  };

  const getCurrentSortValue = () => {
    if (!sortBy || !sortDir) return "price_asc";
    return `${sortBy}_${sortDir}`;
  };

  const loadingItems = loadingProducts || loadingFilters;

  return (
    <Box className={classes.root}>
      {isXsDown && <EmployeeStoreClosedStoreBadge />}
      {loadingItems ? (
        <Skeleton variant="text" width={"100%"} />
      ) : (
        <Typography variant="h6" className={classes.counterPagination}>
          {`${t("PAGINATION_PAGE")} ${toNumber(page)} ${t(
            "PAGINATION_OF"
          )} ${totalPages} - `}
          {t("EMPLOYEE_STORE.SHOWING_RESULTS_COUNT", {
            sizeProducts: resultsCounter,
            totalItems,
          })}
        </Typography>
      )}
      <Box className={classes.endItems}>
        {loadingItems ? null : (
          <Box className={classes.containerSelectBox}>
            <span className={classes.selectLabel}>
              {t("EMPLOYEE_STORE.ORDER_BY_TITLE")}{" "}
            </span>
            <Select
              value={getCurrentSortValue()}
              variant="outlined"
              size="small"
              classes={{ select: classes.select }}
              native
              disableUnderline
              onChange={handleSortChange}
              fullWidth={isXsDown}
            >
              <option value="name_asc">
                {t("EMPLOYEE_STORE.ORDER_BY_OPTION_NAME_ASC")}
              </option>
              <option value="name_desc">
                {t("EMPLOYEE_STORE.ORDER_BY_OPTION_NAME_DESC")}
              </option>
              <option value="price_asc">
                {t("EMPLOYEE_STORE.ORDER_BY_OPTION_PRICE_ASC")}
              </option>
              <option value="price_desc">
                {t("EMPLOYEE_STORE.ORDER_BY_OPTION_PRICE_DESC")}
              </option>
            </Select>
          </Box>
        )}
        {isMdUp ? (
          <>
            <Divider orientation="vertical" flexItem />
            <Box className={classes.buttonsChangeShowModeContainer}>
              <ButtonGroup>
                <Button
                  startIcon={<Icon className="fas fa-th-large" />}
                  color={
                    showHomeProductsMode === MODE_GRID ? "primary" : undefined
                  }
                  onClick={showHomeAsGrid}
                  size="small"
                >
                  Ver Grilla
                </Button>
                <Button
                  startIcon={<Icon className="fas fa-list" />}
                  color={
                    showHomeProductsMode === MODE_LIST ? "primary" : undefined
                  }
                  onClick={showHomeAsList}
                  size="small"
                >
                  Ver Lista
                </Button>
              </ButtonGroup>
            </Box>
          </>
        ) : null}
      </Box>
    </Box>
  );
}
